module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-crying-dark-7aaf44e61d3c8e861149b1bebab77b53.svg";